<template>
    <div class="activity-indicator-double-pulse">
        <div class="activity-indicator-double-pulse-bounce1" />
        <div class="activity-indicator-double-pulse-bounce2" />
    </div>
</template>